import { useQuery } from '@tanstack/react-query'
import { apiFetch } from '../lib/api'
import type { UserEventDashboard } from '@fellowship/shared'

export function useMyDashboard() {
  return useQuery({
    queryKey: ['users', 'me', 'dashboard'],
    queryFn: () => apiFetch<{ data: UserEventDashboard }>('/users/me/dashboard'),
    staleTime: 2 * 60 * 1000,
  })
}
